// Product Collection Cart Slider Swiper Module
// Extracted from theme.js for modular loading
// Used for product sliders in cart collection

(function() {
    // Function to remove opacity after initialization
    function removeOpacity(element) {
        if (element) {
            element.style.opacity = '1';
            element.style.transition = 'opacity 0.3s ease-in';
        }
    }

    function initProductCollectionCartSlider(element) {
        const productGrid = element.querySelector('.products-carousel');
        if (!productGrid) return null;

        // Verify it's a valid DOM element
        if (!(productGrid instanceof Element)) {
            console.warn('Product grid is not a valid Element:', productGrid);
            return null;
        }

        // Check if Slick is already initialized (avoid conflict)
        if (productGrid.classList.contains('slick-initialized')) {
            // console.log('Product collection cart slider already using Slick, skipping Swiper initialization');
            return null;
        }

        // Check if already initialized
        if (productGrid.classList.contains('swiper-initialized')) {
            return productGrid.swiperInstance;
        }

        // Validate Swiper structure - need wrapper and slides
        let wrapper = productGrid.querySelector('.swiper-wrapper');
        if (!wrapper) {
            // If no wrapper, wrap existing children
            wrapper = document.createElement('div');
            wrapper.className = 'swiper-wrapper';

            // Move all direct children into wrapper
            while (productGrid.firstChild) {
                const child = productGrid.firstChild;
                if (child.nodeType === 1) { // Element node
                    child.classList.add('swiper-slide');
                }
                wrapper.appendChild(child);
            }
            productGrid.appendChild(wrapper);

            // Add pagination and navigation containers
            const pagination = document.createElement('div');
            pagination.className = 'swiper-pagination';
            productGrid.appendChild(pagination);

            const nextBtn = document.createElement('div');
            nextBtn.className = 'swiper-button-next';
            productGrid.appendChild(nextBtn);

            const prevBtn = document.createElement('div');
            prevBtn.className = 'swiper-button-prev';
            productGrid.appendChild(prevBtn);
        }

        const itemDots = productGrid.dataset.itemDots === 'true';
        const itemArrows = productGrid.dataset.itemArrows === 'true';

        const swiper = new Swiper(productGrid, {
            slidesPerView: 1,
            slidesPerGroup: 1,
            spaceBetween: 15,
            loop: false,
            watchOverflow: true,
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
                enabled: true
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
                enabled: false
            },
            breakpoints: {
                1025: {
                    pagination: {
                        enabled: itemDots
                    },
                    navigation: {
                        enabled: itemArrows
                    }
                }
            },
            on: {
                init: function() {
                    // Remove opacity after initialization
                    removeOpacity(productGrid);
                    // Update lazy load after initialization
                    if (window.lazyLoadInstance) {
                        window.lazyLoadInstance.update();
                    }
                },
                slideChange: function() {
                    // Update lazy load on slide change
                    if (window.lazyLoadInstance) {
                        window.lazyLoadInstance.update();
                    }
                }
            }
        });

        // Store instance for later use
        productGrid.swiperInstance = swiper;
        return swiper;
    }

    // Initialize all product collection cart sliders with Intersection Observer
    function initAllProductCollectionCartSliders() {
        const productCarts = document.querySelectorAll('[data-product-collection-cart]');
        if (!productCarts.length) return;

        // Apply opacity 0 initially
        productCarts.forEach(element => {
            const productGrid = element.querySelector('.products-carousel');
            if (productGrid && !productGrid.classList.contains('swiper-initialized')) {
                productGrid.style.opacity = '0';
            }
        });

        // Create Intersection Observer
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    initProductCollectionCartSlider(entry.target);
                    observer.unobserve(entry.target);
                }
            });
        }, {
            rootMargin: '100px' // Start loading 100px before visible
        });

        // Observe all product carts
        productCarts.forEach(element => {
            observer.observe(element);
        });
    }

    // Initialize on DOM ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initAllProductCollectionCartSliders);
    } else {
        initAllProductCollectionCartSliders();
    }

    // Export functions for external use
    window.initProductCollectionCartSlider = initProductCollectionCartSlider;
    window.initAllProductCollectionCartSliders = initAllProductCollectionCartSliders;
})();

